import { getRouteApi } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SegmentCriteriaForm } from '@admin/components/segments/segment-criteria-form.tsx';
import { DataTableSkeleton } from '@r/components/data-table/data-table-skeleton.tsx';
import { useApiAdminsegmentsIdGet } from '@r/api/generated/client.ts';
import { useOrvalQueryErrorToast } from '@r/hooks/use-orval-error-toast.ts';

const routeApi = getRouteApi('/auth-layout/settings/segments/$id');

/** Page de gestion des règles d'un segment existant, identifié par l'id dans l'URL. */
export default function SegmentEdit() {
  const { t } = useTranslation();
  const { id } = routeApi.useParams();

  const segmentQuery = useApiAdminsegmentsIdGet(id);
  useOrvalQueryErrorToast(segmentQuery, t('toast.error.label'));

  if (segmentQuery.isLoading || !segmentQuery.data) {
    return <DataTableSkeleton columnCount={3} rowCount={4} />;
  }

  return <SegmentCriteriaForm segment={segmentQuery.data} />;
}
